export const defaultScreen = {
    'title': 'Desktop',
    'type': 'desktop',
    'dimensions': {
        'width': 700,
        'height': 550
    },
    'orientation': 'vertical'
};

export const screens =  [
    defaultScreen,
    {
        'title': 'Tablet Vertical',
        'type': 'tablet',
        'dimensions': {
            'width': 768,
            'height': 1024
        },
        'orientation': 'vertical'
    },
    {
        'title': 'iPad Landscape',
        'type': 'tablet',
        'dimensions': {
            'width': 1024,
            'height': 768
        },
        'orientation': 'horizontal'
    },
    {
        'title': 'Mobile Vertical',
        'type': 'mobile',
        'dimensions': {
            'width': 414,
            'height': 736
        },
        'orientation': 'vertical'
    },
    {
        'title': 'Mobile Horizontal',
        'type': 'mobile',
        'dimensions': {
            'width': 736,
            'height': 414
        },
        'orientation': 'horizontal'
    }
];
